import { reduce, each, set } from 'lodash';

const GEOFENCING_SUPPORTED_COUNTRIES = {
  US: 'US',
  AE: 'AE',
  AU: 'AU',
  NZ: 'NZ',
  GB: 'GB',
  DE: 'DE',
  FR: 'FR',
  IE: 'IE',
  IT: 'IT',
  DK: 'DK',
  FI: 'FI',
  SE: 'SE',
  ES: 'ES',
  BE: 'BE',
  NL: 'NL',
  PL: 'PL',
  AT: 'AT',
  PT: 'PT',
  BG: 'BG',
  HR: 'HR',
  CZ: 'CZ',
  EE: 'EE',
  GR: 'GR',
  HU: 'HU',
  LV: 'LV',
  LT: 'LT',
  LU: 'LU',
  RO: 'RO',
  SK: 'SK',
  SI: 'SI',
  NO: 'NO',
  CH: 'CH',
  CA: 'CA',
  KR: 'KR',
  JP: 'JP',
  CN: 'CN',
};

const GEOFENCING_SHOP_IDS = {
  AE: 'AE',
  AU: 'AU',
  BE: 'BE',
  CA: 'CA',
  CN: 'CN',
  EU: 'EU',
  IE: 'IE',
  JP: 'JP',
  KR: 'KR',
  LU: 'LU',
  NL: 'NL',
  NZ: 'NZ',
  UK: 'UK',
  US: 'US',
};

const GEOFENCING_SHOPS = {
  [GEOFENCING_SHOP_IDS.US]: {
    id: GEOFENCING_SHOP_IDS.US,
    url: 'https://www.allbirds.com',
  },
  [GEOFENCING_SHOP_IDS.AU]: {
    id: GEOFENCING_SHOP_IDS.AU,
    url: 'https://www.allbirds.com.au',
  },
  [GEOFENCING_SHOP_IDS.NZ]: {
    id: GEOFENCING_SHOP_IDS.NZ,
    url: 'https://www.allbirds.co.nz',
  },
  [GEOFENCING_SHOP_IDS.UK]: {
    id: GEOFENCING_SHOP_IDS.UK,
    url: 'https://www.allbirds.co.uk',
  },
  [GEOFENCING_SHOP_IDS.CN]: {
    id: GEOFENCING_SHOP_IDS.CN,
    url: 'https://www.allbirds.cn',
  },
  [GEOFENCING_SHOP_IDS.EU]: {
    id: GEOFENCING_SHOP_IDS.EU,
    url: 'https://www.allbirds.eu',
  },
  [GEOFENCING_SHOP_IDS.JP]: {
    id: GEOFENCING_SHOP_IDS.JP,
    url: 'https://www.allbirds.jp',
  },
  [GEOFENCING_SHOP_IDS.CA]: {
    id: GEOFENCING_SHOP_IDS.CA,
    url: 'https://www.allbirds.ca',
  },
  [GEOFENCING_SHOP_IDS.KR]: {
    id: GEOFENCING_SHOP_IDS.KR,
    url: 'https://www.allbirds.co.kr',
  },
  [GEOFENCING_SHOP_IDS.AE]: {
    id: GEOFENCING_SHOP_IDS.AE,
    url: 'https://www.allbirds.ae',
  },
  [GEOFENCING_SHOP_IDS.BE]: {
    id: GEOFENCING_SHOP_IDS.BE,
    url: 'https://www.allbirdsbenelux.nl',
  },
  [GEOFENCING_SHOP_IDS.IE]: {
    id: GEOFENCING_SHOP_IDS.IE,
    url: 'https://www.allbirdsbenelux.nl/en',
  },
  [GEOFENCING_SHOP_IDS.LU]: {
    id: GEOFENCING_SHOP_IDS.LU,
    url: 'https://www.allbirdsbenelux.nl',
  },
  [GEOFENCING_SHOP_IDS.NL]: {
    id: GEOFENCING_SHOP_IDS.NL,
    url: 'https://www.allbirdsbenelux.nl',
  },
};

const GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP = {
  [GEOFENCING_SHOP_IDS.US]: [GEOFENCING_SUPPORTED_COUNTRIES.US],
  [GEOFENCING_SHOP_IDS.AE]: [GEOFENCING_SUPPORTED_COUNTRIES.AE],
  [GEOFENCING_SHOP_IDS.AU]: [GEOFENCING_SUPPORTED_COUNTRIES.AU],
  [GEOFENCING_SHOP_IDS.NZ]: [GEOFENCING_SUPPORTED_COUNTRIES.NZ],
  [GEOFENCING_SHOP_IDS.UK]: [GEOFENCING_SUPPORTED_COUNTRIES.GB],
  [GEOFENCING_SHOP_IDS.BE]: [GEOFENCING_SUPPORTED_COUNTRIES.BE],
  [GEOFENCING_SHOP_IDS.IE]: [GEOFENCING_SUPPORTED_COUNTRIES.IE],
  [GEOFENCING_SHOP_IDS.LU]: [GEOFENCING_SUPPORTED_COUNTRIES.LU],
  [GEOFENCING_SHOP_IDS.NL]: [GEOFENCING_SUPPORTED_COUNTRIES.NL],
  [GEOFENCING_SHOP_IDS.EU]: [
    GEOFENCING_SUPPORTED_COUNTRIES.DE,
    GEOFENCING_SUPPORTED_COUNTRIES.FR,
    GEOFENCING_SUPPORTED_COUNTRIES.IT,
    GEOFENCING_SUPPORTED_COUNTRIES.DK,
    GEOFENCING_SUPPORTED_COUNTRIES.FI,
    GEOFENCING_SUPPORTED_COUNTRIES.SE,
    GEOFENCING_SUPPORTED_COUNTRIES.ES,
    GEOFENCING_SUPPORTED_COUNTRIES.PL,
    GEOFENCING_SUPPORTED_COUNTRIES.AT,
    GEOFENCING_SUPPORTED_COUNTRIES.PT,
    GEOFENCING_SUPPORTED_COUNTRIES.BG,
    GEOFENCING_SUPPORTED_COUNTRIES.HR,
    GEOFENCING_SUPPORTED_COUNTRIES.CZ,
    GEOFENCING_SUPPORTED_COUNTRIES.EE,
    GEOFENCING_SUPPORTED_COUNTRIES.GR,
    GEOFENCING_SUPPORTED_COUNTRIES.HU,
    GEOFENCING_SUPPORTED_COUNTRIES.LV,
    GEOFENCING_SUPPORTED_COUNTRIES.LT,
    GEOFENCING_SUPPORTED_COUNTRIES.RO,
    GEOFENCING_SUPPORTED_COUNTRIES.SK,
    GEOFENCING_SUPPORTED_COUNTRIES.SI,
    GEOFENCING_SUPPORTED_COUNTRIES.NO,
    GEOFENCING_SUPPORTED_COUNTRIES.CH,
  ],
  [GEOFENCING_SHOP_IDS.JP]: [GEOFENCING_SUPPORTED_COUNTRIES.JP],
  [GEOFENCING_SHOP_IDS.CA]: [GEOFENCING_SUPPORTED_COUNTRIES.CA],
  [GEOFENCING_SHOP_IDS.KR]: [GEOFENCING_SUPPORTED_COUNTRIES.KR],
  [GEOFENCING_SHOP_IDS.CN]: [GEOFENCING_SUPPORTED_COUNTRIES.CN],
};

const GEOFENCING_COUNTRY_TO_SHOP_SUPPORT_MAP = reduce(
  GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP,
  (acc, countries, shopID) => {
    each(countries, country => set(acc, [country], shopID));

    return acc;
  },
  {}
);

export {
  GEOFENCING_COUNTRY_TO_SHOP_SUPPORT_MAP,
  GEOFENCING_SHOP_TO_COUNTRY_SUPPORT_MAP,
  GEOFENCING_SHOPS,
  GEOFENCING_SHOP_IDS,
  GEOFENCING_SUPPORTED_COUNTRIES,
};
